import { CompactUserResponse } from '@business/entities/account';
import { ProductStatus, TimeMaterialId } from './TimeMaterialResponse';
import { OrderProductResponse } from '../order';
import { ACHMethodRequest, CompactOrgResponse, OrgAddressResponse, SimpleOrgResponse } from '../organization';
import { ChangeOrderDiscountResponse } from './TMDiscountResponse';
import { CategoryResponse } from '../category';
import { TMEstimateFeeResponse } from './TMEstimateResponse';
import { TMInvoiceScheduleId } from './TMInvoiceScheduleResponse';
import { ProjectServiceResponse } from '../project';
import { VeryCompactProviderResponse } from './TmServiceProviderResponse';
import { CategoryOptionResponse } from '../category_option';
import { TMChangeOrderActions, TMChangeOrderTypeResponse } from './TMChangeOrderTypeResponse';

export type TMChangeOrderLineId = string;
export interface TMChangeOrderLineResponse {
  id: TMChangeOrderLineId;
  product: OrderProductResponse | null;
  isCustom: boolean;
  customTitle: string | null;
  category: CategoryResponse;
  provider: VeryCompactProviderResponse;
  option: CategoryOptionResponse;
  service?: ProjectServiceResponse;
  quantity: number;
  // unitPrice: number;
  laborPrice: number;
  materialPrice: number;
  markupFactor: number;
  description: string;
  total: number;
  subTotal: number;
  totalMarkup: number;
  status: ProductStatus;
  received: number;
  issuedQuantity?: number;
  warehouseStatus?: string;
  dependantFactor: number;
}

export enum TMChangeOrderStatus {
  open = 'open',
  sent = 'sent',
  approved = 'approved',
  paid = 'paid',
  pending = 'pending',
  declined = 'declined',
}

export type TMChangeOrderId = string;
export interface TMChangeOrderResponse {
  id: TMChangeOrderId;
  tmId: TimeMaterialId;
  invoiceId: TMInvoiceScheduleId;
  items: TMChangeOrderLineResponse[];
  createdBy: CompactUserResponse;
  createdAt: number;
  amount: number;
  billingAddress?: OrgAddressResponse;
  organization?: CompactOrgResponse | SimpleOrgResponse;
  name?: string;
  title?: string;
  orderNumber?: string;
  description?: string;
  signedAt?: number;
  sign?: string;
  status: TMChangeOrderStatus;
  salesTax?: number;
  isInternal: boolean;
  type: TMChangeOrderTypeResponse | null;
  // What the logged-in user can do with it, and whether the client can sign it now (Sent, a type the client signs)
  can: TMChangeOrderActions;
  clientCanSign: boolean;
  discount: ChangeOrderDiscountResponse;
  fees: TMEstimateFeeResponse[];
  total: number;
  subTotal: number;
  subTotalIncMarkup: number;
  url: string;
  halfUrl: string;
  salesReps: string[];
}

export interface TMChangeOrderDepositAchRequest extends Omit<ACHMethodRequest, 'phone'> {
  save: boolean;
  amount: number;
  address?: Partial<OrgAddressResponse>;
}

export type TMChangeOrdeRDepositCardRequest = {
  name: string;
  cardNumber: string;
  expiryMonth: number | string;
  expiryYear: number | string;
  cvv: string;
  save: boolean;
  amount: number;
  address?: Partial<OrgAddressResponse>;
};
